import { z } from 'zod';
import { IntegrationContainerBaseConfig } from '../../../base';
import {
    ThreadUpsertContainerProps,
    ThreadUpsertRouteProps,
} from './integrationUpsertProps';

export function createThreadUpsertRoute(
    config: IntegrationContainerBaseConfig & {
        keys: {
            integrationUrlParam: string;
        };
        Container: React.FC<ThreadUpsertContainerProps>;
    }
): React.FC<ThreadUpsertRouteProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        Container,
    } = config;

    const UrlParamsSchema = z.object({
        [config.keys.integrationUrlParam]: z.string(),
    });

    return () => {
        const params = useOptions(UrlParamsSchema);
        const integration = { id: params[config.keys.integrationUrlParam] };
        return <Container integration={integration} />;
    };
}
